$(document).ready(function(){
  $('.avis-slider').on('init', function(){
      $(".avis-container").addClass("fade-in")
  }).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay:true,       
     
        nextArrow: $(".avis-arrow-right"),
        prevArrow: $(".avis-arrow-left"),
        responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false
              }
            },
        ]
       
       
  });
});

$(document).ready(function(){
    $('.avis-slider-3').on('init', function(){
        $(".avis-container").addClass("fade-in")
    }).slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay:true,
         
       
          nextArrow: $(".avis-arrow-right"),
          prevArrow: $(".avis-arrow-left"),
          responsive: [
              {
                breakpoint: 750,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows:false
                }
              },
          ]
         
         
    });
  });